export const DOCUMENTS_STATISTICS = "DOCUMENTS_STATISTICS";
export const DOCUMENTS_STATISTICS_SUCCESS = "DOCUMENTS_STATISTICS_SUCCESS";
export const DOCUMENTS_STATISTICS_ERROR = "DOCUMENTS_STATISTICS_ERROR";
export const DOCUMENTS_STATISTICS_CLEAR_DATA =
  "DOCUMENTS_STATISTICS_CLEAR_DATA";
